'use strict';

jQuery($ => {

    class ParallaxContent {
        sections = [];
        lastScrollPosition = -1;

        bounds = 100;

        constructor() {
            $('.gecko-parallax__viewport').each((i, el) => {
                this.sections.push(el);
            });

            if (this.sections.length > 0) {
                this.scrollLoop();
            }
        }

        scrollLoop() {
            if (this.lastScrollPosition == window.pageYOffset) {
                requestAnimationFrame(() => {
                    this.scrollLoop();
                });
                return false;
            } else {
                this.lastScrollPosition = window.pageYOffset;
                this.sections.forEach(el => {
                    this.calculateSectionTravel(el);
                });
            }
            requestAnimationFrame(() => {
                this.scrollLoop();
            });
        }

        calculateSectionTravel(el) {
            const image = $(el).find('.gecko-parallax__item');

            let checkBottom = this.lastScrollPosition + $(window).innerHeight();

            let top = $(el).offset().top;
            let center = $(el).height() / 2;
            let checkPoint = top + center;

            if (checkPoint < checkBottom && checkPoint > this.lastScrollPosition) {
                let distanceFromBottom = checkBottom - checkPoint;
                let travelPercent = ((distanceFromBottom / $(window).innerHeight()) * 100).toFixed(0);
                // console.log(travelPercent);
                let progressMultiplier = this.bounds / 100;
                let progress = Math.floor(progressMultiplier * travelPercent);
                image.css({
                    transform: 'translateY('+progress+'px)',
                });
            }
        }
    }

    $(document).ready(() => {
        const parallaxContent = new ParallaxContent();
    });

});